import { buttonType } from 'src/components/button';
import { ActionType } from 'src/services/v2/order/const';

/* eslint-disable camelcase */

export enum FinalStatus {
    待确认 = 1,
    已取消 = 4,
    待发货 = 2,
    已发货 = 3,
    交易成功 = 5,

    退货_申请 = 6,
    退货_客服处理退货 = 8,
    退货_商家处理退货_不能取消 = 23, // 客服发起的状态，商家不能取消
    退货_商家同意退货 = 7,
    退货_客服同意退货 = 10,
    退货_已退货 = 11,
    退货_客服处理退款 = 13,
    退货_商家同意退款 = 12,
    退货_客服同意退款 = 14,
    退货_退货取消 = 15,
    退货_退款成功 = 24, // 仅货到付款订单
    退货_在线退款成功 = 22, // 仅在线支付订单
    退货_退款失败 = 9,
    退货_商家拒绝退货 = 27,
    退货_客服拒绝退货_款 = 28, // 客服拒绝退货和退款都是它
    退货_商家拒绝退款 = 29,

    仅退款_申请 = 30,
    仅退款_取消 = 31,
    仅退款_同意 = 32,
    仅退款_成功 = 38, // 仅货到付款订单
    仅退款_在线退款成功 = 39, // 仅在线支付订单
    仅退款_商家拒绝 = 33,
    仅退款_客服拒绝 = 36,
    仅退款_客服处理 = 34,
    仅退款_客服同意 = 35,
    仅退款_失败 = 37,

    仅退款_售前_申请 = 16,
    仅退款_售前_同意 = 17,
    仅退款_售前_申请客服介入 = 18, // 废弃，兼容历史订单
    仅退款_售前_客服支持商户 = 19, // 废弃，兼容历史订单
    仅退款_售前_客服支持用户 = 20, // 废弃，兼容历史订单
    仅退款_售前_成功 = 21,
    仅退款_售前_取消 = 25,
    仅退款_售前_拒绝 = 26
}

// 最近一次操作路径 用于判断订单只有一个失败状态的时候区分失败原因
export enum LatelyOperateStep {
    用户申请 = 1,
    商户第一次审核,
    客服第一次仲裁,
    用户填写物流,
    商户第二次审核,
    客服第二次仲裁
}
export interface PolicyInfoItem {
    ins_policy_no: string;
    status: number;
    status_desc: string;
    policy_type: string;
    policy_detail: string;
    policy_amount?: number;
}

export interface IMainAftersale {
    return: {
        available: number;
    };
    refund: {
        available: number;
    };
    can_apply: number;
    unapply_reason: string;
    can_refund_post: number;
    refund_post_amount: number;
    can_part_refund: number;
    part_refund_amount: number;
}

export interface IMainPresale {
    can_apply: number;
    unapply_reason: string;
    apply_type: 'SHOP' | 'PRODUCT';
}

export interface IMainOrder {
    order_id: string;
    // 售后单 ID，不存在则无售后
    aftersale_id?: string;
    user_id: number;
    user_type: number;
    user_name: string;
    shop_order_status: number;
    order_status: number;
    final_status: FinalStatus;

    service_process_type: number; // 1为玉石类订单
    service_process_status: number; // 1为玉石类订单待鉴定，3为玉石类订单鉴定完成
    service_process_conclusion: number; // 1为玉石类订单鉴定通过
    biz: number; // 8用于判断玉石类订单退款申请时间为12小时内

    lately_operate_step?: LatelyOperateStep;
    shop_id: string;
    product_id: string;
    combo_id: number;
    combo_amount: number;
    combo_num: number;
    pay_type: 0 | 1 | 2;
    biz_type: number;
    sub_b_type: 0 | 1 | 2 | 3; //  0-未知；1-app；2-小程序；3-H5
    b_type: number;
    post_amount: number;
    total_amount: number;
    post_code?: string;
    post_receiver: string;
    post_tel: string;
    logistics_id: number;
    logistics_time: number;
    logistics_code: string;
    receipt_time: number;
    buyer_words: string;
    seller_words: string;
    cancel_remark: string;
    urge_cnt: number;
    is_comment: number;
    coupon_meta_id: string;
    campaign_info?: {
        campaign_name: string;
        sale_price: number;
    };
    coupon_info?: {
        platform_coupon_amount: number;
        shop_coupon_amount: number;
    };
    platform_campaign_tag_list?: {
        tag_icon_url: string;
    }[];
    extra: {
        // 订单取消时间
        order_expire_time: number;
        /**
         * @description 预计发货时间
         */
        exp_ship_time: number;
        /**
         * @description 商品类型
         * 0 是普通订单
         * 2 虚拟商品订单
         * 4 卡券类
         */
        order_type: '0' | '2' | '4';
        /**
         * @description 预售类型
         * 0 非预售
         * 1 预售
         */
        pre_sale_type: '0' | '1';
        supply_id: number;
        v_type?: number;
        campaign?: {
            order_expire_time?: number;
            meta?: {
                stype: number;
                campaign_id: string;
            };
        };
        platform_full_discount?: number;
        shop_full_discount?: number;
    };
    pid: string;
    shop_tel: string;

    shop_name: string; // 店铺名称
    old_shop_name: string; // 后端给订单列表改版ABtest新加的店铺名称，测试完之后下线

    wechat: string;
    product_name: string;
    img: string;
    product_pay_type: 0 | 1 | 2;
    product_platform: string;
    out_product_id: string;
    create_time: string;
    update_time: number;
    gift_spec_desc: string;
    spec_desc: string;
    post_addr: string;
    order_status_str: string;
    has_coupon_banner: number;
    origin_type: string;
    origin_id: string;
    comment_op: number;
    service_tel: string;
    report_id__for_event: number;
    refund_create_timestamp?: number;
    refund_referee_timestamp?: number;
    refund_referee_comment?: string;
    refund_shop_comment?: string;
    refund_refuse_reason?: string;
    aftersale_apply_timestamp?: number; // 申请售后时间
    aftersale_logistics_timestamp?: number; // 售后用户发货时间
    aftersale_referee_again_timestamp?: number; // 售后同意退款时间
    ship_text: string;
    logistics?: {
        express_company: string; // 物流公司拼音
        express_company_icon: string; // 物流公司图标
        postman_tel: string; // 快递员手机号
        name: string; // 物流公司中文名
        trackingno: string; // 运单编号
        signatory: string; // 签收人
        data: Array<{
            title: string; // 物流状态
            icon: string; // 状态图标
            state: string;
            time: string;
            ftime: string; // 物流展示以这个为准
            context: string; // 物流状态详细信息
        }>;
    };
    snapshot_url?: string;
    addr_edited?: number; // 是否编辑过地址，非零值编辑过
    voucher?: IOrderVoucher[]; // 券码列表，order_type=4时有
    voucher_expire_at?: number; // 券码过期绝对时间戳
    can_apply_aftersale: boolean; // 能否申请售后
    aftersale_service: unknown;
    has_snapshot?: boolean;

    shop_logo?: string; // 店铺头像
    shop_user_id?: string; // 达人店铺的达人uid，用于跳转抖音达人橱窗
    shop_sec_user_id?: string; // 达人店铺的达人加密uid，用于跳转抖音达人橱窗
    referrer_name?: string; // 推荐人名称
    referrer_user_id?: string; // 推荐人uid，用于跳转抖音达人橱窗
    referrer_sec_user_id?: string; // 推荐人加密uid，用于跳转抖音达人橱窗

    // 评价有礼
    comment_gift?: {
        credit: number; // 单位，分
    };

    // 货到付款退款线上化
    refund_type?: 'ONLINE' | 'OFFLINE'; // 是否是货到付款退款线上化订单
    refund_status?: number; // 值为4的时候表示退款失败
    need_modify_payee?: boolean; // 退款失败状态需要用户重新填写打款信息
    need_payee?: boolean; // 退货申请状态是否需要用户填写打款信息
    aftersale_type?: number; // 订单类型
    aftersale_status?: number; // 换货状态
    test_tag?: string; // AB流量实验 json {"caijing":"B"}  B财经流量  A 或者key为空:电商原流量
    policy_info?: PolicyInfoItem[]; // 退货运费险
    is_multi_package?: boolean; // 是否多包裹订单
    sent_package_count?: number; // 已发包裹数量
    exp_ship_time?: number; // 剩余包裹承诺发货时间

    can_delete?: boolean; // 是否展示 删除订单
}

export interface IOrderVoucher {
    code: string; // 券码
    code_id: string; // 券码 id
    status: 1 | 2 | 3; // 券码状态：1-有效，2-已使用，3-已过期
    res_id: string; // 资源ID
    res_order_id: string; // 资源订单ID
}

export interface ISubOrder
    extends Pick<
        IMainOrder,
        | 'order_id'
        | 'product_id'
        | 'product_name'
        | 'origin_type'
        | 'origin_id'
        | 'img'
        | 'spec_desc'
        | 'total_amount'
        | 'post_amount'
        | 'combo_id'
        | 'combo_amount'
        | 'combo_num'
        | 'coupon_info'
        | 'campaign_info'
        | 'final_status'
        | 'pay_type'
        | 'biz_type'
        | 'sub_b_type'
        | 'b_type'
        | 'comment_op'
        | 'has_coupon_banner'
        | 'extra'
        | 'create_time'
        | 'update_time'
        | 'is_comment'
        | 'receipt_time'
        | 'can_apply_aftersale'
        | 'policy_info'
        | 'platform_campaign_tag_list'
        | 'logistics_time'
        | 'logistics'
    > {
    [index: string]: any;
}

export interface IOrder extends IMainOrder {
    sub_orders: ISubOrder[];
    // 标记是否是自订单， 用于OrderId过滤
    isMainOrder?: boolean;
}

export interface IPureOrderAction {
    name: string;
}

export interface IOrderActionWithStyle extends IPureOrderAction {
    /**
     *  @description 额外的支付按钮样式
     */
    class?: buttonType;
}

export interface IOrderAction extends IOrderActionWithStyle {
    /**
     * button 的类型
     */
    type?: ActionType;
    /**
     * @description 跳转链接
     */
    link?: {
        link: string;
        title: string;
        type: string;
    };
}

// 订单中心切往订单详情的行为枚举
export enum EActionEnum {
    Cancel = 'cancel',
    Pay = 'payagain'
}
